import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import Header from '../Home/Header'
import PaydayForm from '../Payday/PaydayForm'
import BillsForm from '../Bills/BillsForm'
import SavingsForm from '../Savings/SavingsForm'
import ExpenseForm from '../Expenses/ExpenseForm'

const AddAcountInfo = props => {
  const [username] = useState(props.location.state.username)
  const [step, setStep] = useState(1)

  const nextStep = () => {
    setStep(step + 1)
  }

  let content

  switch (step) {
    case 1:
      content = <PaydayForm nextStep={nextStep} username={username} />
      break
    case 2:
      content = <BillsForm nextStep={nextStep} username={username} />
      break
    case 3:
      content = <ExpenseForm nextStep={nextStep} username={username} />
      break
    case 4:
      content = <SavingsForm nextStep={nextStep} username={username} />
      break
    case 5:
      content = (<Redirect to={{
        pathname: '/logged-in',
        state: { username }
      }} />)
      break
    default:
      content = <PaydayForm nextStep={nextStep} username={username} />
  }

  return (
    <div className='add-account-info bg-middle-green'>
      <Header />
      <h1 className='home-title roboto fw700 white ls25 font375'>
        Account Info
      </h1>
      <div
        className='bg-middle-blue'
        style={{ height: '2px', width: '7em', margin: '1em auto 1.75em' }}
        aria-hidden='true'
      />
      {content}
    </div>
  )
}

export default AddAcountInfo
